import {PageService} from 'hasta-la-vista-middleware-api/service'
import {MovieService} from 'hasta-la-vista-middleware-api/service'
import MetaData from  '../../../mixins/meta-data.js'
import Vue from 'vue'

export default {
  name: 'faq',

  data () {
    return {
      heading: 'Frequently asked questions',
      subheading: 'Find the answers to your questions here',
      tabs: [],
      errors: [],
      loading: true,
      activeTab: false,
      currentIndex: 0,
      related_movies: []
    }
  },

  created () {
    this.getContent()
  },

  methods: {
    isActive(index, name){

      console.log("isActive", index, name)
          console.log(name)

          

      return index == this.currentIndex
    },

    getContent() {
      this.loading = true
      if(this.$breakpoints.xs || this.$breakpoints.sm) {
        Vue.nextTick(() => {
          if(this.$parent.$el != undefined) window.scroll({top: (this.$parent.$el.offsetTop - 100), left: 0, behavior: 'smooth'})
        })
      }
      Promise.all([PageService.getFAQ(), MovieService.getMovies()]).then(([faqs, movies])=>{
        this.tabs = faqs.data.reduce((collection, tab)=>{
           var found = collection.findIndex((col)=>col.name == tab.category);
           if(~found){
             collection[found].items.push(tab);
           }else{
             collection.push({name:tab.category,items:[tab]});
           }
           return collection
       },[])
        
        this.related_movies = movies.byRelease().now_showing
        this.loading = false
      })
    }
  },

  watch: {
    '$route' () {
      this.getContent()

      
    },
  },

  beforeMounted() {
    this.getContent()
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/faqs/faq.js